import { render } from "./textAreaField.vue?vue&type=template&id=721f6f2f"
import script from "./textAreaField.vue?vue&type=script&lang=js"
export * from "./textAreaField.vue?vue&type=script&lang=js"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__